import axios from "axios";

export const uploadSheet = (
  endpointUrl: string,
  fileData: any,
  key: string,
  setUploadProgress: any,
  setUploadView: any,
  setSuccessWindow: any,
  setFailedWindow: any,
  setErrorWindow: any,
  failedWindow: any,
  successWindow: any,
  getData?: any,
  getAllClientData?: any
) => {
  const token = localStorage.getItem("dm_access_token");
  const formData = new FormData();
  formData.append(key, fileData);
  axios
    .post(endpointUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress: (data: any) => {
        setUploadProgress(Math.round((data?.loaded / data?.total) * 100));
      },
    })
    .then((response) => {
      setUploadView(false);
      setUploadProgress(0);
      setUploadView("");
      if (response?.data?.data?.errorMessages?.length > 0) {
        const errorMessageArr = response?.data?.data?.errorMessages;
        setErrorWindow({
          status: true,
          message: errorMessageArr?.reduce(
            (acc: any, curr: any) => acc + "\n" + curr
          ),
        });
      } else if (response?.data?.data?.failedhargerIds?.length > 0) {
        const failedMessageArr = response?.data?.data?.failedhargerIds;
        setFailedWindow({
          ...failedWindow,
          status: true,
          message: failedMessageArr?.reduce(
            (acc: any, curr: any) => acc + "\n" + curr
          ),
        });
      } else {
        getData();
        getAllClientData();
        setSuccessWindow({
          ...successWindow,
          status: true,
          message: "File has been uploaded successfully",
        });
      }
      return response;
    })
    .catch((error) => {
      setUploadView("");
      let joinedMessage: string = "";
      if (error?.response?.data?.data?.length > 0) {
        joinedMessage = error?.response?.data?.data.join(", ");
      }
      setFailedWindow({
        ...failedWindow,
        status: true,
        message:
          joinedMessage ?? error?.response?.data?.message ?? error?.Message,
      });
    });
};
